import { transformCurrencyAmountDto } from 'data/transformers/currency-amount';
export const transformOrder = dto => ({
  id: dto.id,
  charityCode: dto.charity_code,
  totalAmount: transformCurrencyAmountDto(dto.total_amount),
  payableAmount: transformCurrencyAmountDto(dto.payable_amount),
  termsNote: dto.terms_note
});